export default {
    to: "/dashboard/partners",
    order: 3,
    icon: "mdi-handshake",
    title: "Partners",
    disabled: false,
    value: 0,
    sublinks: [],
}
